import { useMemo } from 'react';
import { useEntityStore } from '@ContractBuilder/store';
import { isEndorsementData } from '@ContractBuilder/types';

import type { ThreadMarkInput } from '../utils/inject-thread-marks';
import { getBlockThreads } from '../utils/threads';

/** Anchors of the block's open inline threads, for the read-view marks. Empty on endorsements (comments are hidden there). */
export const useBlockThreadAnchors = (blockId: string): ThreadMarkInput[] => {
  const comments = useEntityStore(({ submission }) => submission?.comments);
  const isEndorsement = useEntityStore(({ submission }) => isEndorsementData(submission));

  return useMemo(
    () =>
      isEndorsement
        ? []
        : getBlockThreads(blockId, comments)
            .filter((thread) => thread.isAnchored && !thread.isResolved)
            .map((thread) => ({
              threadId: thread.id,
              start: thread.root.anchor!.start,
              end: thread.root.anchor!.end,
              text: thread.root.anchor!.text,
            })),
    [blockId, comments, isEndorsement],
  );
};
